import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import ReceiptIcon from '@material-ui/icons/Receipt';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import HourglassFullTwoToneIcon from '@material-ui/icons/HourglassFullTwoTone';
import Box from '@material-ui/core/Box';
import { withNamespaces } from 'react-i18next';
import i18next from 'i18next';
import ExpenseAccountForm from './ExpenseAccountForm'
import ExpenseAccountWaiting from './ExpenseAccountWaiting'

function TabPanelExpenseAccount(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`scrollable-force-tabpanel-${index}`}
            aria-labelledby={`scrollable-force-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanelExpenseAccount.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `scrollable-force-tab-${index}`,
        'aria-controls': `scrollable-force-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));

function ScrollableTabsButtonForce({ t }) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const expenseClick = () => {
        setIndex(0);
    }

    const waitingClick = () => {
        setIndex(1);
    }

    const historyClick = () => {
        setIndex(2);
    }

    return (
        <React.Fragment>
            <div data-id="headerExpenseAccount" className={classes.root}>
                <AppBar position="static" color="default">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="standard"
                        indicatorColor="primary"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        <Tab className={"TabPageButton"} label={i18next.t('expenseAccount:tabPanel.expense')} {...a11yProps(0)} onClick={expenseClick} />
                        <Tab className={"TabPageButton"} label={t('expenseAccount:tabPanel.waiting')} {...a11yProps(1)} onClick={waitingClick} />
                        <Tab className={"TabPageButton"} label={t('expenseAccount:tabPanel.history')} {...a11yProps(2)} onClick={historyClick} />
                    </Tabs>
                </AppBar>
            </div>
            {index == 0 && <ExpenseAccountForm />}
            {index == 1 && <ExpenseAccountWaiting loadCharge={'N'} />}
            {index == 2 && <ExpenseAccountWaiting loadCharge={'O'}/>}
        </React.Fragment>
    );
}

export default withNamespaces(['expenseAccount'], { wait: true })(ScrollableTabsButtonForce);